/**
 * Split lines
 *
 * @param {HTMLElement} element - The HTML element whose text content should be split into lines.
 * @returns {Object} An object containing el, items, children and offsetHeight.
 */
export default async function splitLines(element) {
  const linesToSplit = element;

  let currentTop = 0;
  let formattedText = '';

  // @TODO handle <br>
  linesToSplit.innerHTML = element.textContent.replace(/\S+/g, '<n>$&</n>');

  try {
    await document.fonts.ready;
  } catch {
    // also proceed on error
  }

  await new Promise((resolve) => {
    requestAnimationFrame(resolve);
  });

  const childSpans = element.children;

  for (let i = 0; i < childSpans.length; i += 1) {
    const rectTop = childSpans[i].getBoundingClientRect().top;
    if (currentTop < rectTop) {
      formattedText += '</span></span><span class="split-line"><span>';
    }
    currentTop = rectTop;
    formattedText += `${childSpans[i].textContent} `;
  }

  formattedText += '</span></span>';
  linesToSplit.innerHTML = formattedText;

  const offsetHeight = childSpans.length ? childSpans[0].offsetHeight : 0;
  const spanChildren = [];

  Array.from(childSpans).forEach((span) => {
    spanChildren.push(span.children[0]);
  });

  return {
    el: linesToSplit,
    items: childSpans,
    children: spanChildren,
    offsetHeight,
  };
}
